import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const LeavedetailsAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		leavetypeid: yup.string().required().label($t('leavetypeid')),
		empcode: yup.string().required().label($t('empcode')),
		financialyear: yup.string().required().label($t('financialyear')),
		apply_for_days: yup.number().required().label($t('applyForDays')),
		approved_for_days: yup.number().required().label($t('approvedForDays')),
		date_from: yup.string().required().label($t('dateFrom')),
		date_to: yup.string().required().label($t('dateTo')),
		remarks: yup.string().nullable().label($t('remarks')),
		status: yup.string().nullable().label($t('status'))
	});
	
	//form default values
	const formDefaultValues = {
		leavetypeid: '', 
		empcode: '', 
		financialyear: '', 
		apply_for_days: '', 
		approved_for_days: '', 
		date_from: new Date(), 
		date_to: new Date(), 
		remarks: '', 
		status: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/leavedetails`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="LeavedetailsAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewLeavedetail')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('leavetypeid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/leavetypeid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="leavetypeid"     optionLabel="label" optionValue="value" value={formik.values.leavetypeid} onChange={formik.handleChange} options={response} label={$t('leavetypeid')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.leavetypeid)}   />
                                                    <ErrorMessage name="leavetypeid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('empcode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/empcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="empcode"     optionLabel="label" optionValue="value" value={formik.values.empcode} onChange={formik.handleChange} options={response} label={$t('empcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.empcode)}   />
                                                    <ErrorMessage name="empcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('financialyear')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/financialyear_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="financialyear"     optionLabel="label" optionValue="value" value={formik.values.financialyear} onChange={formik.handleChange} options={response} label={$t('financialyear')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.financialyear)}   />
                                                    <ErrorMessage name="financialyear" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('applyForDays')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="apply_for_days"  onChange={formik.handleChange}  value={formik.values.apply_for_days}   label={$t('applyForDays')} type="number" placeholder={$t('enterApplyForDays')}  min={0}  step="any"    className={inputClassName(formik?.errors?.apply_for_days)} />
                                                <ErrorMessage name="apply_for_days" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('approvedForDays')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="approved_for_days"  onChange={formik.handleChange}  value={formik.values.approved_for_days}   label={$t('approvedForDays')} type="number" placeholder={$t('enterApprovedForDays')}  min={0}  step="any"    className={inputClassName(formik?.errors?.approved_for_days)} />
                                                <ErrorMessage name="approved_for_days" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('dateFrom')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="date_from" showButtonBar className={inputClassName(formik?.errors?.date_from)} dateFormat="yy-mm-dd" value={formik.values.date_from} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="date_from" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('dateTo')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="date_to" showButtonBar className={inputClassName(formik?.errors?.date_to)} dateFormat="yy-mm-dd" value={formik.values.date_to} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="date_to" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('remarks')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="remarks"  onChange={formik.handleChange}  value={formik.values.remarks}   label={$t('remarks')} type="text" placeholder={$t('enterRemarks')}        className={inputClassName(formik?.errors?.remarks)} />
                                                <ErrorMessage name="remarks" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('status')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="status"     optionLabel="label" optionValue="value" value={formik.values.status} onChange={formik.handleChange} options={app.menus.status} label={$t('status')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.status)}   />
                                                <ErrorMessage name="status" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
LeavedetailsAddPage.defaultProps = {
	primaryKey: 'leavedetailid',
	pageName: 'leavedetails',
	apiPath: 'leavedetails/add',
	routeName: 'leavedetailsadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default LeavedetailsAddPage;
